import React from 'react';
import { Icon, IconProps } from './Icon';

export const UsersPlusIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" {...props}>
      <path d="M2 21a8 8 0 0 1 13.292-6" />
      <circle cx="10" cy="8" r="5" />
      <path d="M19 16v6" />
      <path d="M22 19h-6" />
    </Icon>
  );
};
